export default [{
    path: '/settings',
    name: 'settings',
    component: () =>
        import ('@/views/pages/settings/Settings.vue'),
    meta: {
        pageTitle: 'Settings',
        breadcrumb: [{
            text: 'Settings',
            active: true,
        }, ],
        resource: 'settings',
        action: 'read',
    },
}, ]